import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import QuizFlow1 from '../components/quiz/flow1/QuizFlow1'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors } from '@components/shared'
import TopNav from '@components/TopNav'
import { BannerText, TopBanner } from '@components/quiz/quizStyles'
import ConversionPaywallModal from '@components/subscribe/ConversionPaywallModal'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { ANNUAL_PRICE_STRING, ANNUAL_20_OFF_PRICE_STRING } from '../helpers/subscriptionHelpers'

type PropsType = {
  bannerText: string,
  isBannerVisible: boolean
}

type DispatchPropsType = {}

function FantasyQuiz20 (_props: PropsType & DispatchPropsType): React.ReactNode {
  return (
    <FantasyQuiz
      isBannerVisible={true}
      bannerText='You’re one step closer to getting 20% off'
      subscriptionOfferCta='TRY 7 DAYS FREE'
      subscriptionOfferTitle={`<s>${ANNUAL_PRICE_STRING}</s> ${ANNUAL_20_OFF_PRICE_STRING} for 1 year of Dipsea`}
      subscriptionOfferSubtitle={`Discounted subscription of ${ANNUAL_20_OFF_PRICE_STRING} USD billed at 7-day trial end`}
      subscriptionOfferSubtext={`Your card will be charged a sum of ${ANNUAL_20_OFF_PRICE_STRING} USD in one week for the first year of unlimited access to Dipsea. You must cancel your subscription before the end of your one week trial if you do not want to be charged. Your annual subscription will auto-renew for ${ANNUAL_PRICE_STRING} USD thereafter until you cancel. By clicking "Try 7 Days Free", you agree to our Payment Terms.`}
      existingPromoCode='fantasy-quiz-20'
    />
  )
}

function FantasyQuiz (props: {
  isBannerVisible: boolean,
  bannerText?: string,
  subscriptionOfferCta: string,
  subscriptionOfferTitle: string,
  subscriptionOfferSubtitle: string,
  subscriptionOfferSubtext: string,
  existingPromoCode: string
}): React.ReactNode {
  return (
    <PageWrapper isBannerVisible={props.isBannerVisible}>
      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <HtmlHead
        title={`Dipsea | Get lost in a steamy fantasy world`}
        description={
          'Take this short quiz and get matched with your perfect Dipsea series. We\'ve got hundreds of sexy stories designed to turn you on, whatever your fantasy is.'
        }
      />

      {props.isBannerVisible && !!props.bannerText && (
        <TopBanner>
          <BannerText>{props.bannerText}</BannerText>
        </TopBanner>
      )}

      <TopNav
        backgroundColor={colors.midnightBlue95}
        isAssetLoaded={true}
        isMarketingNav={true}
        isPromoModal={true}
      />

      <ConversionPaywallModal
        subtype={'annual'}
        defaultSignIn={true}
        subscriptionOfferCta={props.subscriptionOfferCta}
        subscriptionOfferTitle={props.subscriptionOfferTitle}
        subscriptionOfferSubtitle={props.subscriptionOfferSubtitle}
        subscriptionOfferSubtext={props.subscriptionOfferSubtext}
        existingPromoCode={props.existingPromoCode}
      />

      <QuizFlow1 quizType='fantasy-quiz' />
    </PageWrapper>
  )
}

const mapStateToProps = (state: AppStateType): { bannerText: any, showBanner: any } => {
  return {
    bannerText: 'One step closer to unlimited sexy stories!',
    showBanner: !!(state.promoFlowModalOpen)
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FantasyQuiz20) as any) as any

const PageWrapper = styled.div<any>`
  .quiz-block {
    padding: 90px 20px 30px;
    ${(props: any): any => config(props).media.md`
      padding: 150px 0 30px;
    `}
  }
  .quiz-progres-bar {
    top: ${(props: { isBannerVisible: boolean }): string =>
  props.isBannerVisible ? '32px' : '0'};
    ${(props: any): any => config(props).media.md`
      top: ${(props: { isBannerVisible: boolean }): string =>
  props.isBannerVisible ? '56px' : '0'};
    `}
  }
  .marketing-nav-bar {
    top: ${(props: { isBannerVisible: boolean }): string =>
  props.isBannerVisible ? '32px' : '0'};
    ${(props: any): any => config(props).media.md`
      top: ${(props: { isBannerVisible: boolean }): string =>
  props.isBannerVisible ? '56px' : '0'};
    `}
  }
`
